<script setup lang="ts">
const tenant = useTenant()

defineProps({
  static: {
    type: Boolean,
    default: false,
  },
})
</script>
<template>
  <div class="w-screen max-w-4xl h-full flex flex-row justify-center items-center">
    <div class="flex flex-col items-center">
      <div class="animate-logo flex flex-row items-center">
        <div class="relative" :class="{ 'static-icon': static, 'animate-icon': !static }">
          <img v-if="tenant.instanceLogo" :src="tenant.instanceLogo" :alt="tenant.appName" class="h-12" />
        </div>
        <div v-if="!tenant.logoOnly" class="overflow-hidden flex">
          <div class="font-bold text-2xl ml-2" :class="{ 'static-text': static, 'animate-text': !static }">
            {{ tenant.animationText }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.static-icon {
  opacity: 1;
  top: 0px;
}

.animate-icon {
  animation: 4s 1 normal animate-icon-keyframes;
}

@keyframes animate-icon-keyframes {
  0% {
    opacity: 0;
    top: 10px;
  }

  10% {
    opacity: 1;
    top: 0px;
  }
}

.static-text {
  transform: translateX(0);
}

.animate-text {
  animation-delay: 1s;
  animation-duration: 4s;
  animation-iteration-count: 1;
  animation-name: animate-text-keyframes;
  animation-fill-mode: forwards;
  transform: translateX(-120%);
  transition-property: transform;
  transition-timing-function: ease;
  overflow: hidden;
}

@keyframes animate-text-keyframes {
  0% {
    transform: translateX(-120%);
  }

  30% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(0);
  }
}

/* 
.animate-logo {
    animation: 10s 1 normal animate-logo-keyframes;
    transition-property: all;
}

@keyframes animate-logo-keyframes {
    0% {
        max-height: 3rem;
        overflow: visible;
    }

    70% {
        max-height: 3rem;
        overflow: hidden;
    }

    80% {
        max-height: 0;
    }

    100% {
        max-height: 0;
    }
}

.animate-welcome {
    animation: 10s 1 normal animate-welcome-keyframes;
    transition-property: all;
    overflow: hidden;
}

@keyframes animate-welcome-keyframes {
    0% {
        max-height: 0;
    }

    70% {
        max-height: 0;
    }

    80% {
        max-height: 3rem;
    }

    100% {
        max-height: 3rem;
    }
} */
</style>
